import Icon from 'components/elements/Icon'

import styles from './saltMeter.module.scss'

type Props = {
  salt: number
}

const SaltMeter: React.FC<Props> = ({ salt }: Props) => {
  const percent = (salt / 4) * 100

  return (
    <div className={styles.container}>
      <div className={styles.gauge} style={{ right: `${100 - percent}%` }}>
        <Icon name="angle double up" />

        <div className={styles.score}>{salt}</div>
      </div>

      <div
        className={styles.mask}
        style={{ width: `${100 - percent}%`, borderRadius: percent === 100 ? 5 : '0 5px 5px 0' }}
      />

      {Array.from(Array(15).keys()).map(i => (
        <div
          key={i}
          className={styles.hash}
          style={{ left: `${((i + 1) / 16) * 100}%`, height: (i + 1) % 4 === 0 ? 9 : 4 }}
        />
      ))}
    </div>
  )
}

export default SaltMeter
